export default __webpack_public_path__ + "static/media/product_ico.c0977182.svg";